/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { FancyAction } from '../base/FancyAction';
import { FancyFirebaseList } from '../base/FancyFirebaseList';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

//the firebase representation is different from every use exception days so far
//so unless the potential for metadata starts being used just strip it out for minimal disruption
interface InternalTicketExceptionDays {
	[key: string]: { work: boolean };
}

export type TicketExceptionDays = Map<string, boolean>;

export class TicketExceptionDaysList extends FancyFirebaseList<TicketExceptionDays, FancyAction> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(
		action: AngularFireAction<DatabaseSnapshot<InternalTicketExceptionDays>>
	): TicketExceptionDays {
		const map: TicketExceptionDays = new Map();
		if (!action.payload.exists()) {
			return map;
		}
		this.updateObj(map, action.payload);
		return map;
	}
	public $$updated(
		child: TicketExceptionDays,
		action: AngularFireAction<DatabaseSnapshot<InternalTicketExceptionDays>>
	) {
		child.clear();
		this.updateObj(child, action.payload);
	}

	private updateObj(map: TicketExceptionDays, snapshot: DatabaseSnapshot<any>) {
		snapshot.forEach((childSnapshot) => {
			map.set(childSnapshot.key, childSnapshot.child('work').val());
			// obj[childSnapshot.key] = childSnapshot.child('work').val();
			return false; //current version of the firebase sdk is dumb and requires this, remove when updating
		});
	}

	// //put in interface so you can explicitly say you're doing this
	// applyJoinData(baseKey: string, child, otherChild:any) {
	// 	switch (baseKey) {
	// 		case 'locationColor':
	// 			child.data.color = otherChild ? otherChild.color : null;
	// 			break;
	// 		default: break;
	// 	}
	// }
	// getDataForKey(baseKey: string, child) {
	// 	return child.data[baseKey];
	// }
	// getPrevDataForKey(baseKey: string, child) {
	// 	return child.prevData[baseKey];
	// }
}
